import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material';
import CustomImageComponent from '@/components/shared/custom/custom-image';
import { getTeamImageById } from '@/helpers/images-helper';
import { getCompetitionImage } from '@/helpers/leagues-helper';
import { toPriceInEuros } from '@/helpers/prices-helper';
import { translate } from '@/data/fixture-transalations';

const ShowMarketProjectionTable = ({ projections }) => {
    const rowHeight = 30;
    const getRowBorderStyle = (day) => {
        switch (day) {
            case 5:
                return { borderLeft: '6px solid #1976d2' }; // Azul
            case 7:
                return { borderLeft: '6px solid #2e7d32' }; // Verde
            case 10:
                return { borderLeft: '6px solid #ed6c02' }; // Naranja
            case 14:
                return { borderLeft: '6px solid #d32f2f' }; // Rojo
            default:
                return {};
        }
    };

    const renderFixtureCell = (fixture) => {
        if (!fixture?.homeTeamId) return null;

        return (
            <Box display={'flex'} gap={0.25} alignItems={'center'} justifyContent={'center'}>
                <Box display={'flex'} alignItems={'center'} gap={0.5}>
                    <CustomImageComponent
                        src={getCompetitionImage(fixture?.leagueId, 23)}
                        alt={'competición'}
                        width={15}
                        height={15}
                    />
                    <Typography fontSize={'14px'}>{translate(fixture?.round, true)}</Typography>
                </Box>
                <Box display="flex" alignItems={'center'} gap={0.5}>
                    <CustomImageComponent
                        src={getTeamImageById(fixture.homeTeamId, 30)}
                        alt={fixture.homeTeamName}
                        width={15}
                        height={15}
                    />
                    <CustomImageComponent
                        src={getTeamImageById(fixture.awayTeamId, 30)}
                        alt={fixture.awayTeamName}
                        width={15}
                        height={15}
                    />
                </Box>
            </Box>
        );
    };

    return (
        <TableContainer component={Paper} sx={{ tableLayout: 'fixed' }}>
            <Table
                sx={{
                    '& .MuiTableCell-root': {
                        height: rowHeight,
                        padding: '4px 8px',
                    },
                    '& .MuiTableRow-root': {
                        height: rowHeight,
                    },
                }}
            >
                <TableHead>
                    <TableRow>
                        <TableCell
                            align="center"
                            sx={{
                                width: 60,
                                fontSize: 12,
                            }}
                        >
                            Día
                        </TableCell>
                        <TableCell
                            align="center"
                            sx={{
                                width: 80,
                                fontSize: 12,
                            }}
                        >
                            Fecha
                        </TableCell>
                        <TableCell
                            align="center"
                            sx={{
                                width: 120,
                                fontSize: 12,
                            }}
                        >
                            Proyección
                        </TableCell>
                        <TableCell
                            align="center"
                            sx={{
                                width: 'calc(100% - 270px)',
                                fontSize: 12,
                            }}
                        >
                            Oferta max/min
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {projections?.map((row, index) => {
                        const ofertaMax = (row.value * 1.1).toFixed(0);
                        const ofertaMin = (row.value * 0.9).toFixed(0);
                        return (
                            <TableRow
                                key={index}
                                sx={{
                                    ...getRowBorderStyle(row.day),
                                }}
                            >
                                <TableCell align="center">
                                    <Typography fontSize={12}>
                                        {row.day === 0 ? 'Hoy' : `${row.day}`}
                                    </Typography>
                                </TableCell>
                                <TableCell align="center">
                                    <Typography fontSize={12}>{row.date}</Typography>
                                    {renderFixtureCell(row.fixture)}
                                </TableCell>
                                <TableCell align="center">
                                    <Typography fontSize={12}>{toPriceInEuros(row.value)}</Typography>
                                </TableCell>
                                <TableCell align="center">
                                    <Typography fontSize={12}>{toPriceInEuros(ofertaMax)}</Typography>
                                    <Typography color={'text.secondary'} fontSize={12}>
                                        {toPriceInEuros(ofertaMin)}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ShowMarketProjectionTable;
